import { FileIcon } from "@phosphor-icons/react/dist/csr/File";
import { StarIcon } from "@phosphor-icons/react/dist/csr/Star";
import { QUICKSTART } from "../../constants/externalLinks";
import { Spacer } from "../ui/common";
import { BaseWelcomeMessage } from "../WelcomeMessage";
import { AddDraft, DraftsLink } from "./DraftsCommon";

const NewDraftPrompt = () => (
  <BaseWelcomeMessage icon={FileIcon} title={"Welcome to Drafts!"} supportDocsLink={QUICKSTART}>
    <div className={"welcome-message"} data-test-label="welcome-message">
      Create a new Draft to get started{" "}
      <Spacer>
        {" "}
        <AddDraft />{" "}
      </Spacer>
    </div>
  </BaseWelcomeMessage>
);

const NoPublished = () => (
  <BaseWelcomeMessage icon={StarIcon} title={"Published Drafts!"} supportDocsLink={QUICKSTART}>
    There are no published versions in your account. Navigate to the <DraftsLink /> screen to get started.
  </BaseWelcomeMessage>
);

export { NewDraftPrompt, NoPublished };
